import type { ContentTextProps } from '@/components/molecules/ContentText';
import type { ItemsContainerSectionProps } from '@/components/sections/ItemsContainerSection';

import { INTEGRATION_SIDE_CONFIG } from '../integration/integration-side-content';

type IntegrationPageTypes = {
    titleSection: ContentTextProps;
    integrationContent: ItemsContainerSectionProps;
};

export const HEADING_TEXT_CONFIG = {
    textConfig: [
        {
            type: 'heading1',
            text: 'Integracja',
            dataTestId: 'integration-page-main-heading',
            className: 'text-center md:text-left',
        },
    ],
};

export const INTEGRATION_CONFIG: IntegrationPageTypes = {
    titleSection: HEADING_TEXT_CONFIG as ContentTextProps,
    integrationContent: {
        containerConfig: {
            flexOptions: {
                preset: 'topAlign',
            },
        },
        items: [
            {
                type: 'integration-side-content-template',
                config: INTEGRATION_SIDE_CONFIG,
            },
            {
                type: 'text-content',
                config: {
                    contentTextConfig: {
                        textConfig: [
                            {
                                type: 'heading3',
                                text: 'Wykorzystaj potencjał PayPo w swoim sklepie',
                                'data-test-id': 'integration-page-subheading',
                                className: 'text-center md:text-left mb-8',
                            },
                            {
                                type: 'paragraph',
                                text: 'Integracja z naszym systemem płatności jest prosta i szybka. Tylko dwa kroki dzielą Cię od zwiększenia konwersji na Twojej stronie.',
                                className: 'text-left mb-8',
                            },
                            {
                                type: 'titleText',
                                size: 'm',
                                text: 'W sekcji “Materiały developerskie”',
                                className: 'text-left mb-4',
                            },
                            {
                                type: 'paragraph',
                                text: 'Przygotowaliśmy dla Ciebie gotową dokumentację API do wykorzystania w Twoim e-sklepie. Nasi specjaliści pomogą Ci szybko i skutecznie wdrożyć system płatności na Twojej platformie zakupowej.',
                                className: 'text-left mb-8',
                            },
                            {
                                type: 'titleText',
                                size: 'm',
                                text: 'W sekcji “Materiały marketingowe”',
                                className: 'text-left mb-4',
                            },
                            {
                                type: 'paragraph',
                                text: 'Umieściliśmy materiały informacyjne, które przydadzą Ci się po przeprowadzeniu integracji, aby poinformować klientów o możliwości korzystania z PayPo. Materiały będą wyświetlały się dobrze zarówno na desktopie, jak i urządzeniach mobilnych.',
                                className: 'text-left',
                            },
                        ],
                    },
                },
            },
        ],
    },
};

export const INTEGRATION_COPY_MESSAGE_CONFIG_PL = {
    success: {
        title: 'Udało się!',
        message: 'Kod został skopiowany do schowka.',
        variant: 'success',
        dataTestId: 'integration-copy-code-success-message',
        duration: 5000,
        hasCloseIcon: true,
    },
    error: {
        title: 'Wystąpił błąd',
        message: 'Nie udało się skopiować kodu.',
        duration: 5000,
        variant: 'error',
        dataTestId: 'integration-copy-code-error-message',
        hasCloseIcon: true,
    },
};

export const INTEGRATION_SHOWMORE_TEXT_PL = {
    showMoreLabel: 'Pokaż cały kod',
    showLessLabel: 'Zwiń kod',
};

export const LOGOTYPES_PAYPO = [
    {
        src: '/images/logos/logo-paypo-border.svg',
        alt: '',
        width: 170,
        height: 65,
    },
    {
        src: '/images/logos/logo-paypo-black-white-bg.svg',
        alt: '',
        width: 170,
        height: 65,
    },
    {
        src: '/images/logos/logo-paypo-bg-black.svg',
        alt: '',
        width: 170,
        height: 65,
    },
    {
        src: '/images/logos/logo-paypo-black.svg',
        alt: '',
        width: 170,
        height: 65,
    },
];
